import { Controller } from "@hotwired/stimulus";
import IMask from "imask";

// The card fields of fire/shared/_card (Asaas' lane; Stripe's number and
// expiry live in Stripe's own box).
//
// The number: four by four, except the two brands that are not: amex (34/37)
// groups 4-6-5 and diners (30x/36/38) 4-6-4. The brand shows itself in the
// first two digits, so nobody has to pick one.
//
//   <input data-controller="card-input" inputmode="numeric" autocomplete="cc-number">
//
// The expiry: one box, MM/YY as the card prints it, the slash by itself after
// the month ("1" then "/" is 01, "4" alone is 04).
//
//   <input data-controller="card-input" data-card-input-expiry-value="true"
//          inputmode="numeric" autocomplete="cc-exp">
//
// Formatting only: the eye reads the groups, the server reads the digits
// (Pay::Card.typed splits the expiry for the gateway), and what a card really
// is comes back from the gateway when it is tokenised (Pay::Card).
const AMEX = /^3[47]/;
const DINERS = /^3(0[0-5]|[68])/;

const EXPIRY = {
  mask: "MM/YY",
  lazy: true,
  eager: true,
  blocks: {
    MM: { mask: IMask.MaskedRange, from: 1, to: 12, autofix: "pad" },
    YY: { mask: "00" },
  },
};

const NUMBER = {
  mask: [
    { mask: "0000 0000 0000 0000 000", lazy: true }, // visa, master, elo, up to 19
    { mask: "0000 000000 00000", lazy: true },
    { mask: "0000 000000 0000", lazy: true },
  ],
  dispatch: (appended, dynamic) => {
    const n = (dynamic.value + appended).replace(/\D/g, "");
    return dynamic.compiledMasks[AMEX.test(n) ? 1 : DINERS.test(n) ? 2 : 0];
  },
};

export default class extends Controller {
  static values = { expiry: Boolean };

  connect() {
    this.mask = IMask(this.element, this.expiryValue ? EXPIRY : NUMBER);
  }

  disconnect() {
    this.mask?.destroy();
    this.mask = null;
  }
}
